import { apiService } from './apiWrapper';

/////////POST REQUESTS///////////

export const SIGNIN = (body) => {
  return apiService('auth/login', 'POST', { ...body });
};
export const ADD_USER = (body) => {
  return apiService('user', 'POST', body);
};
export const JOIN_USER = (body) => {
  return apiService('auth/join', 'POST', body);
};

/////////GET REQUESTS///////////
export const AUTH_ME = () => {
  return apiService('user/auth-me', 'GET');
};
export const GET_USER = (params) => {
  return apiService(`user?${params}`, 'GET');
};
export const GET_DRIVER = () => {
  return apiService(`user/driver`, 'GET');
};
export const GET_BOOKING = (params) => {
  return apiService(`booking?${params}`, 'GET');
};
export const GET_SETTING = (params) => {
  return apiService(`setting/66c9fa4d5c64f811eecdf23e`, 'GET');
};
export const GET_COORDINATES = (params) => {
  return apiService(`map/get-coordinates/${params.placeId}/${params.point}`, 'GET');
};
export const GET_NOTIFICATION_COUNT = (params) => {
  return apiService(`booking/count/${params.status}?userId=${params.driverId ? params.driverId : ''}`, 'GET');
};
/////////PUT REQUESTS///////////
export const UPDATE_SETTING = (body) => {
  return apiService(`setting/66c9fa4d5c64f811eecdf23e`, 'PUT', body);
};
export const UPDATE_BOOKING = (id, body) => {
  return apiService(`booking/${id}`, 'PUT', body);
};
export const UPDATE_USER = (id, body) => {
  return apiService(`user/${id}`, 'PUT', body);
};
/////////DELETE REQUESTS///////////
export const DELETE_USER = (id) => {
  return apiService(`user/${id}`, 'DELETE');
};
export const DELETE_BOOKING = (id) => {
  return apiService(`booking/${id}`, 'DELETE');
};
